import { TColor } from "../../types";
import { assertNever } from "../../utils";
import { TAlertColor } from "./types";

export const getAlertColors = (
    type: TAlertColor
): Record<
    | "backgroundColor"
    | "badgeBackground"
    | "borderColor"
    | "iconColor"
    | "supportingTextColor"
    | "textBackground"
    | "textColor",
    TColor
> => {
    switch (type) {
        case "error": {
            return {
                backgroundColor: "error-25",
                badgeBackground: "error-600",
                borderColor: "error-300",
                iconColor: "error-600",
                supportingTextColor: "error-600",
                textBackground: "error-50",
                textColor: "error-700"
            };
        }
        case "grey": {
            return {
                backgroundColor: "surface-25",
                badgeBackground: "surface-800",
                borderColor: "surface-800",
                iconColor: "surface-800",
                supportingTextColor: "surface-800",
                textBackground: "surface-50",
                textColor: "surface-800"
            };
        }
        case "heads-up": {
            return {
                backgroundColor: "tertiary-25",
                badgeBackground: "tertiary-700",
                borderColor: "tertiary-700",
                iconColor: "tertiary-700",
                supportingTextColor: "tertiary-700",
                textBackground: "tertiary-50",
                textColor: "tertiary-700"
            };
        }
        case "success": {
            return {
                backgroundColor: "success-25",
                badgeBackground: "success-600",
                borderColor: "success-300",
                iconColor: "success-600",
                supportingTextColor: "success-600",
                textBackground: "success-50",
                textColor: "success-700"
            };
        }
        case "warning": {
            return {
                backgroundColor: "warning-25",
                badgeBackground: "warning-500",
                borderColor: "warning-300",
                iconColor: "warning-700",
                supportingTextColor: "warning-700",
                textBackground: "warning-50",
                textColor: "warning-700"
            };
        }
        default:
            return assertNever(type, true);
    }
};
